import React, {use, useEffect, useState} from 'react';
import ReactPlayer from 'react-player/lazy'
import MultiRangeSlider from "multi-range-slider-react";
import Play from '../adminIcons/Play.svg'
import Forward from '../adminIcons/Forward.svg'
import Backward from '../adminIcons/Backward.svg'
import { formatSeconds } from '../../utils/formatTime'

const TrackTimes = (props) => {

    const [videoRef, setVideoRef] = useState(0)

    const [minValue, set_minValue] = useState(0);
    const [maxValue, set_maxValue] = useState(0);
    const [playing, setPlaying] = useState(false)
    const [position, setPosition] = useState(1)
    const [duration, setDuration] = useState(0)

    let fullTrack = {}

    const handleInput = (e) => {
        if(props.addedTracks && props.addedTracks.length ){
            setPosition(props.addedTracks[props.addedTracks.length - 1].position+1)
            if(props.addedTracks[props.addedTracks.length - 1].end_time <= e.minValue){
                set_minValue(e.minValue);
            } else {
                alert("Value Shouldn't override previous Track")
            }
        } else {
            set_minValue(e.minValue);
        }
        set_maxValue(e.maxValue);
    };

    useEffect(()=>{
        set_maxValue(duration)
    },[duration])

    useEffect(()=>{
        console.log(props.addedTracks)
        if(props.addedTracks && props.addedTracks.length>0){
            set_minValue(props.addedTracks[props.addedTracks.length - 1].end_time+1)
        }
    },[props.addedTracks])

    const backWardHandler = () => {
        if(minValue < videoRef?.getCurrentTime()-10){
            videoRef?.seekTo(videoRef?.getCurrentTime() - 10)
        } else {
            videoRef?.seekTo(minValue)
        }
    }

    const forWardHandler = () => {
        if(maxValue > videoRef?.getCurrentTime()+10){
            videoRef?.seekTo(videoRef?.getCurrentTime()+10)
        } else {
            videoRef?.seekTo(maxValue)
        }
    }

    const playClickhandler = () => {
        videoRef?.seekTo(minValue)
        setPlaying(true)
    }

    const handleProgress = (changeState) => {
        if(changeState.playedSeconds > maxValue){
            setPlaying(false)
        }
    }

    const resetHandler = () => {
        if(props.addedTracks && props.addedTracks.length){
            set_minValue(props.addedTracks[0].end_time)
        } else {
            set_minValue(0)
        }
        set_maxValue(duration)
    }


    const handleSave = () => {
        fullTrack.album_title = props.album.title
        fullTrack.catalogue_num = props.album.catalogue_num
        fullTrack.album_id  = props.album.id
        fullTrack.track_id = props.track.id
        fullTrack.track_title = props.track.title
        fullTrack.genre = props.track.genre
        fullTrack.artists = props.track.artists
        fullTrack.composers = props.track.composers
        fullTrack.start_time = Math.round(minValue)
        fullTrack.end_time = Math.round(maxValue)
        fullTrack.position = position
        props.setAddedTracks(prev=>[...prev, fullTrack])
        props.setIsActive(false)
    }

    return (
        <div className = "d-flex flex-column align-items-center">
            <div className='d-flex align-items-center pb-4'>
                <div className = "fs-7 text-primary pe-3" style={{fontWeight:"800"}}>ADD TRACK</div>
                <div className='text-primary' style={{fontWeight:"500"}}>{props.track.title}</div>
            </div>
            <ReactPlayer
                ref = {setVideoRef}
                className='react-player'
                controls
                url={ props.videoUrl }
                onProgress={handleProgress}
                onReady={()=>setDuration(videoRef?.getDuration())}
                playing = {playing}
                config={{
                    file: {
                    attributes: {
                        controlsList: 'nodownload nofullscreen'
                    }
                    }
                    }}
                width="600px"
            />
            <div className = "pt-5 track-range-slider" style={{width:"600px"}}>
                <style>{`
                    .track-range-slider .multi-range-slider .thumb::before {
                        width: 20px !important;
                        height: 20px !important;
                        background-color: #FFCD00 !important;
                        border: none !important;
                        margin-top: -8px !important;
                        display: block !important;
                        z-index: 99 !important;
                    }
                    .track-range-slider .multi-range-slider .bar-inner-right,
                    .track-range-slider .multi-range-slider .bar-inner,
                    .track-range-slider .multi-range-slider .bar-left,
                    .track-range-slider .multi-range-slider .bar-right {
                        pointer-events: none;
                    }
                    .track-range-slider .multi-range-slider .thumb {
                        pointer-events: auto;
                        z-index: 99 !important;
                        position: relative !important;
                        margin-top: 4px !important;
                        visibility: visible !important;
                    }
                `}</style>
                {  duration && maxValue &&
                    <>
                        <MultiRangeSlider
                            min={0}
                            max={duration}
                            step={1}
                            minValue={minValue}
                            maxValue={maxValue}
                            minCaption={formatSeconds(minValue)}
                            maxCaption={formatSeconds(maxValue)}
                            ruler={false}
                            label={false}
                            style={{border:'none', boxShadow:"none", padding: "15px 10px"}}
                            barLeftColor='#011A33'
                            barRightColor='#011A33'
                            barInnerColor='#00C8D5'
                            thumbLeftColor={'#FFCD00'}
                            thumbRightColor={'#FFCD00'}
                            onInput={(e) => {
                                handleInput(e);
                            }}
                        />
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <div style={{ margin: '10px' }}>duration:</div>
                            <div style={{ margin: '10px' }}>{formatSeconds(minValue)}</div>
                            <div style={{ margin: '10px' }}>{formatSeconds(maxValue)}</div>
                        </div>
                    </>
                }
            </div>
            <div className = "d-flex justify-content-between" style={{width:"600px"}}>
                <div
                    className = "bg-transparent rounded-pill border border-secondary text-secondary px-5 py-2"
                    role = 'button'
                    onClick={()=>resetHandler()}
                    >Reset</div>
                <div className = "bg-primary py-2 px-5 rounded-pill">
                    <img
                        className='pe-4'
                        src = {Backward}
                        role = 'button'
                        onClick={()=>backWardHandler()}
                        alt = ""/>
                    <img
                        src = {Play}
                        role = 'button'
                        onClick={()=>playClickhandler()}
                        alt = "" />
                    <img
                        className='ps-4'
                        src = {Forward}
                        role = 'button'
                        onClick={()=>forWardHandler()}
                        alt = ""/>
                </div>
                <div
                    className = "bg-secondary rounded-pill text-white px-5 py-2"
                    role = 'button'
                    onClick={()=>handleSave()}
                    >Save</div>
            </div>
        </div>
    );
};

export default TrackTimes;